import * as React from "react";
import FAQAccordion, { FAQAccordionProps } from "~/components/faq-accordion/faq-accordion";

export interface FAQAccordionViewProps {
    contextModel: FAQAccordionProps;
}

class FAQAccordionView extends React.PureComponent<FAQAccordionViewProps> {
    public render() {
        return <FAQAccordion {...this.props.contextModel} />;
    }
}

export default FAQAccordionView;
